export const INITIAL_REFERRAL_PARAMS_STATE = {
  isReferralPage: false,
  referralCode: null
};

export const INITIAL_GIFTED_PARAMS_STATE = {
  isGifted: false,
  gifter: "",
  email: ""
};

export const QUERY_PARAMS = {
  REFERRAL_CODE: "referral_code",
  GIFTING: "gifting",
  EMAIL: "email",
  GIFTER: "gifter"
};
